import { Box, Stack } from "@mui/material";
import background from "../../../assets/icons/hero-landingPage.png";
import HeroLeft from "./HeroLeft/HeroLeft";
import HeroRight from "./HeroRight/HeroRight";
import Navbar from "../../../components/Navbar/Navbar";
import { HeroContainer, HeroHolder, HeroImage } from "./BusinessPage.styles";

const HeroComponent = () => {
  return (
    <HeroContainer>
      <Navbar />
      <HeroHolder>
        <HeroLeft />
        <HeroRight />
      </HeroHolder>
    </HeroContainer>
  );
};

export default HeroComponent;
